import React, { useState, useRef } from "react";
import { TextField } from "@material-ui/core";
import { isNumber, isSpecial } from "../../lib/Common";
function Name(props) {
  const classes = props.useStyles();
  const [errorText, setErrorText] = useState("");
  const [errorValue, setErrorValue] = useState(false);
  const nameRef = useRef(null);
  return (
    <TextField
      className={classes.TextField}
      autoFocus
      required
      fullWidth
      inputRef={nameRef}
      error={errorValue}
      helperText={errorText}
      label="이름(Name)"
      type="text"
      variant="filled"
      onBlur={(e) => {
        if ( isNumber.test(e.target.value) || isSpecial.test(e.target.value) ){
          setErrorText("한글 / 영문만 입력 가능합니다.");
          setErrorValue(true);
          nameRef.current.focus();
        }else if (e.target.value.length <= 1) {
          setErrorText("2글자 이상 데이터 입력하세요.");
          setErrorValue(true);
          nameRef.current.focus();
        } else {
          setErrorText("");
          setErrorValue(false);
          props.onChangeName(e.target.value);
        }
        
      }}
      name="name"
      defaultValue={props.name}
    />
  );
}
export default Name;
